import { useQuery, gql } from '@apollo/client';

export const GET_ALL_DOCUMENT_IMPORTER_TEMPLATES = gql`
  query getAllHealthInsurance {
    getAllDocumentImporterTemplates {
      _id
      title
    }
  }
`;

export const useGetAllDocumentImporterTemplates = () => {
  const { data, loading } = useQuery(GET_ALL_DOCUMENT_IMPORTER_TEMPLATES, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    importerTemplates: data?.getAllDocumentImporterTemplates || [],
    loading,
  };
};
